<template>
    <div class="container">
        <v-card>
            <v-card-title>
                Consulta desagregada por información territorial
            </v-card-title>
            <v-card-text>
                <v-card :loading="loading" :disabled="loading">
                    <v-card-title>
                        Filtros
                    </v-card-title>
                    <v-card-text>

                        <v-tabs
                            show-arrows
                            next-icon="fa-caret-right"
                            prev-icon="fa-caret-left"
                            background-color="blue-grey lighten-4"
                            horizontal
                        >
                            <v-tabs-slider></v-tabs-slider>
                            <v-tab @click="clearsearch"> <v-icon left>folder</v-icon>por ubicación </v-tab>
                            <v-tab @click="clearsearch"> <v-icon left>work</v-icon>por indicador </v-tab>
                            <v-tab-item>
                                <v-flex>
                                    <v-select clearable label="Sub-Region:" item-text="nombre" item-value="idsubregion" :disabled="iddepartamento != null" 
                                        :no-data-text="gnodata" :items="gSubregiones" v-model="idsubregion" @change="ActualizarMunicipio" >
                                    </v-select>                            
                                </v-flex>
                                <v-flex>
                                    <v-select clearable label="Departamentos:" item-text="nombre" item-value="iddepartamento" :disabled="idsubregion != null" 
                                        :no-data-text="gnodata" :items="gDepartamentos" v-model="iddepartamento" @change="ActualizarMunicipio" >
                                    </v-select>                            
                                </v-flex>
                                <v-flex>
                                    <v-select clearable label="Municipios:" item-text="nombre" item-value="idmunicipio" :disabled="idsubregion == null && iddepartamento == null" 
                                        :no-data-text="gnodata" :items="gMunicipiosByelemento" v-model="idmunicipio" @change="filtrar" >
                                    </v-select>                            
                                </v-flex>
                                <v-flex>
                                    <v-select clearable label="Periodos:" item-text="nombre" item-value="idperiodo" :disabled="idsubregion == null && iddepartamento == null" 
                                        :no-data-text="gnodata" :items="gperiodos" v-model="idperiodo" @change="filtrar" >
                                    </v-select>                            
                                </v-flex>  

                            </v-tab-item>

                            <v-tab-item>
                                <v-card>
                                    <v-card-title>
                                        <v-flex>
                                            <v-text-field
                                            v-model="search"
                                            append-icon="search"
                                            label="Buscar"
                                            single-line
                                            hide-details
                                            ></v-text-field>
                                        </v-flex>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-data-table
                                        :headers="headerIndicador"
                                        :items="gindicadoresterritorializacion"
                                        class="elevation-1"
                                        :search="search"
                                        :no-data-text="gnodata"
                                        :no-results-text="gnosearch"   
                                        :items-per-page="3"                                     
                                        >
                                        <template v-slot:[`item.action`]="{ item }">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                <v-icon v-on="on" small class="mr-2" @click="buscarindicador(item)"
                                                    v-scroll-to="'#containera'" >fa-solid fa-eye</v-icon >

                                                </template>
                                                <span>Buscar</span>
                                            </v-tooltip>
                                        </template>
                                        </v-data-table>
                                        <v-flex >
                                            <v-select clearable label="Periodo:" item-text="nombre" item-value="idperiodo" :disabled="idindicador == null" 
                                                :no-data-text="gnodata" :items="gperiodos" v-model="idperiodo" @change="filtrarporindicador" >
                                            </v-select>                                                    
                                        </v-flex>
                                    </v-card-text>
                                </v-card>
                                
                            </v-tab-item>

                        </v-tabs>                                                                      
                        <v-flex id="containera" ref="containera">
                            <v-data-table
                            :headers="headerFields"
                            :items="DataGeometas"
                            class="elevation-2"
                            :no-data-text="gnodata"
                            dense
                            :items-per-page="10"
                            >
                            <template v-slot:top>
                            <v-toolbar>
                                <v-toolbar-title>Lista de Geo Metas</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                                <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon x-large v-on="on" @click="newgeometa"
                                    v-scroll-to="'#containera'" >
                                    <v-icon color="primary">add</v-icon>
                                    </v-btn>
                                </template>
                                <span>Agregar</span>
                                </v-tooltip>
                            </v-toolbar>
                            </template>                            
                            <template v-slot:footer>
                                <div id="div1" style="width:100%;align:right">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                    <download-excel id="div2"  style="width:100%;text-align: right;"
                                        v-show="DataGeometas.length>0"
                                        class="btn btn-default"
                                        :data="DataGeometas"
                                        :exportFields="exportable"
                                        name="Territorializacion.xls"
                                        type="xls"
                                        worksheet="Data"
                                    >
                                    
                                        <v-icon color="secondary"  v-on="on" large elevation="2">mdi-file-download-outline</v-icon>
                                    </download-excel>
                                    </template>
                                    <span>Descargar</span>
                                </v-tooltip>
                                </div>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" small class="mr-2" @click="editgeometa(item)" >edit</v-icon>
                                    </template>
                                    <span>Editar</span>
                                </v-tooltip>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-icon small v-on="on" @click="deletegeometa(item)">delete</v-icon>
                                    </template>
                                    <span>Eliminar</span>
                                </v-tooltip>
                            </template>                            

                            </v-data-table>                            
                        </v-flex>
                    </v-card-text>
                </v-card>
            </v-card-text>
        </v-card>
    <v-snackbar v-model="snack" :timeout="5000" :color="MesaggeInfo.color">
      {{ this.MesaggeInfo.codigoRespuesta }}
      {{ this.MesaggeInfo.mensajeRespuesta }}
      <v-btn text @click="snack = false">Cerrar</v-btn>
    </v-snackbar>

    <v-dialog v-model="dialog" max-width="900px">
        <v-card>
            <v-card-title >
                <v-flex md12 sm12 v-show="IndexGeometa >= 0">
                    Indicador {{ DataEditGeometas.indicador }}, desagregacion {{ DataEditGeometas.desagregacion }}, periodo {{ DataEditGeometas.periodo }}
                </v-flex>    
                <v-flex md12 sm12 v-show="IndexGeometa == -1">
                    Indicador - ({{ NombreIndicador }})
                </v-flex>    
                   
            </v-card-title>
            <v-card-text>
                <v-layout wrap justify-space-between>
                    <v-flex md4 sm12>
                        <v-select :items="gDepartamentos" 
                            item-text="nombre"
                            item-value="iddepartamento"
                            v-model="DataEditGeometas.iddepartamento" 
                            @change="Filtrarmunicipio"
                            
                            clearable
                            class="mx-2"
                            label="Departamento:" ></v-select>                        
                    </v-flex>
                    <v-flex md4 sm12>
                        <v-select :items="gSubregiones" 
                            item-text="nombre"
                            item-value="idsubregion"
                            v-model="DataEditGeometas.idsubregion" 
                            
                            @change="Filtrarmunicipio"
                            clearable
                            class="mx-2"
                            label="Sub Regiones:" ></v-select>                         
                    </v-flex>  
                    <v-flex md4 sm12>
                        <v-select :items="gMunicipiosByelemento" 
                            item-text="nombre"
                            item-value="idmunicipio"
                            v-model="DataEditGeometas.idmunicipio" 
                            :disabled="DataEditGeometas.idsubregion == null && DataEditGeometas.iddepartamento == null"
                            clearable
                            @change="MesaggeAlert = ''; idmunicipio = DataEditGeometas.idmunicipio"
                            class="mx-2"
                            label="Municipio:" ></v-select>                         
                    </v-flex>  
                    <v-flex md4 sm12>
                        <v-select :items="gdesagregacionpoblacional" 
                            item-text="nombre"
                            item-value="iddesagregacion"
                            v-model="DataEditGeometas.iddesagregacion" 
                            :disabled="DataEditGeometas.idsubregion == null && DataEditGeometas.iddepartamento == null"
                            class="mx-2"
                            @change="MesaggeAlert = '';"
                            label="Desagregacion:" ></v-select>                         
                    </v-flex>    
                    <v-flex md4 sm12>
                        <v-select :items="gperiodos" 
                            item-text="nombre"
                            item-value="idperiodo"
                            v-model="DataEditGeometas.idperiodo" 
                            :disabled="DataEditGeometas.idsubregion == null && DataEditGeometas.iddepartamento == null"
                            @change="MesaggeAlert = ''; idperiodo = DataEditGeometas.idperiodo"
                            class="mx-2"
                            label="Periodo:" ></v-select>                         
                    </v-flex>    
                    <v-flex md4 sm12>
                        <v-text-field
                          v-model="DataEditGeometas.valor"
                          :disabled="DataEditGeometas.idmeta == null"
                          label="Valor:"
                          class="mx-2"
                          v-validate="'decimal:2'"
                          data-vv-name="ValorGeometa"
                          :error-messages="errors.collect('ValorGeometa')"                          
                        ></v-text-field>                    
                    </v-flex>    
                    <v-flex md4 sm12>
                        <v-checkbox
                            v-model="DataEditGeometas.general"
                            class="mx-2"
                            label="General"
                        ></v-checkbox>                   
                    </v-flex>   
                    <v-flex md12 sm12 v-show="IndexGeometa == -1 && DataEditGeometas.idperiodo != null">
                        <v-card>
                            <v-card-title>
                                <v-flex>
                                    <v-text-field
                                        v-model="search"
                                        append-icon="search"
                                        label="Buscar"
                                        single-line
                                        hide-details
                                    ></v-text-field>
                                </v-flex>
                            </v-card-title>
                            <v-card-text>
                                <v-data-table
                                :headers="headerIndicadordialog"
                                :items="gindicadoresterritorializacion"
                                class="elevation-1"
                                :search="search"
                                :no-data-text="gnodata"
                                :no-results-text="gnosearch"   
                                :items-per-page="3"                                     
                                >
                                    <template v-slot:[`item.action`]="{ item }">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" small class="mr-2" @click="Selecionarindicador(item)"
                                                v-scroll-to="'#containera'" >fa-solid fa-eye</v-icon >
                                            </template>
                                            <span>Seleccionar</span>
                                        </v-tooltip>
                                    </template>                                
                                </v-data-table>
                            </v-card-text>
                        </v-card>

                    </v-flex> 
                </v-layout>

            <v-alert dense text colored-border dismissible elevation="2" border="left" type="warning" :value="MesaggeAlert.length > 0" >
                <v-flex xs12 sm6>  
                    {{MesaggeAlert}}
                </v-flex>        
            </v-alert>

            </v-card-text>
            <v-card-actions>
              <v-btn color="blue darken-1" @click="dialog = false">Cancelar</v-btn>
              <v-btn color="blue darken-1" @click="PreventGuardar">Guardar</v-btn>
            </v-card-actions>            
        </v-card>
    </v-dialog>    

    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "GeoMetas",
  data() {
    return {
        search: '',
        DataGeometas: [],
        DataEditGeometas: [],
        idsubregion:null,
        iddepartamento:null,
        idmunicipio:null,
        idperiodo:null,
        idindicador:null,
        NombreIndicador: '',
        loading: false,
        recargar: false,
        snack: false,
        snackColor: "",
        snackText: "",    
        buttontext: "cerrar", 
        dialog: false,   
        IndexGeometa:-1,
        MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],
        MesaggeAlert: '',
        headerFields: [
            { text: "ID", value: "idgeometa", align: " d-none"  },
            { value: "idmeta", text: "idmeta", align: " d-none" },
            { value: "idsubregion", text: "idsubregion", align: " d-none" },
            { value: "iddepartamento", text: "iddepartamento", align: " d-none" },
            { value: "idmunicipio", text: "idmunicipio", align: " d-none" },
            { value: "iddesagregacion", text: "iddesagregacion", align: " d-none" },
            { value: "idperiodo", text: "idperiodo", align: " d-none" },
            { value: "indicador", text: "Indicador" },
            { value: "departamento", text: "Departamento" },
            { value: "municipio", text: "Municipio" },
            { value: "subregion", text: "Subregion" },
            { value: "desagregacion", text: "Desagregacion" },
            { value: "periodo", text: "Año" },
            { value: "valor", text: "Valor" },
            { value: "general", text: "general" },
            { text: "Acciones", value: "action", sortable: false },
        ],
        headerIndicador: [
            { text: "ID", value: "idindicador", align: " d-none"  },
            { value: "codigo", text: "Codigo" },        
            { value: "nombre", text: "Nombre" },
            { text: "Acción", value: "action", sortable: false, width: 100 },
        ],
        headerIndicadordialog: [
            { text: "ID", value: "idindicador", align: " d-none"  },
            { value: "codigo", text: "Codigo" },
            { text: "Acción", value: "action", sortable: false, width: 50 },
        ],        
        exportable: {
            Codigo: "indicador",
            Departamento: "departamento",
            Municipio: "municipio",
            Subregion: "subregion",
            Desagregacion: "desagregacion",
            Año: "periodo",
            Valor: "valor",
            "General":"general"
        },
        dictionary: {
            custom: {
                ValorGeometa: {
                    decimal: "solo numeros con el siguiente formato (.##) ",
                },
            },  
        }
                   
    };
  },
  mounted() {
    this.$validator.localize("es", this.dictionary);
  },  
  methods: {
    ...mapActions(["getSubregiones"
    , "getDepartamentos"
    , "geometasfiltrados"
    , "aperiodicidad"
    , "getMunicipiosbyelemento"
    , "geometasbyindicador"
    , "get_indicadorbyterritorializacion"
    , "eliminargeometa"
    , "get_desagregacionpoblacional"
    , "ActualizarGeometa"
    , "getmetasperiodo"
    , "InsertarGeometa"]),
    filtrar() {
        this.geometasfiltrados({
            params: {
                idsubregion: this.idsubregion == null ? 0 : this.idsubregion, 
                iddepartamento: this.iddepartamento == null ? 0 : this.iddepartamento, 
                idmunicipio: this.idmunicipio == null ? 0 : this.idmunicipio, 
                idperiodo: this.idperiodo == null ? 0 : this.idperiodo
                }}); 
    },
    filtrarporindicador() {
        this.geometasbyindicador({
            params: {
                idindicador: this.idindicador == null ? 0 : this.idindicador,  
                idperiodo: this.idperiodo == null ? 0 : this.idperiodo
                }});
    },
    ActualizarMunicipio(){
        this.getMunicipiosbyelemento({
            params: {
                idsubregion: this.idsubregion == null ? 0 : this.idsubregion, 
                iddepartamento: this.iddepartamento == null ? 0 : this.iddepartamento
            }
        });
        this.filtrar();
    },
    Filtrarmunicipio(){
        this.idsubregion = this.DataEditGeometas.idsubregion;
        this.iddepartamento = this.DataEditGeometas.iddepartamento;
        this.MesaggeAlert = '';
        this.getMunicipiosbyelemento({
            params: {
                idsubregion: this.idsubregion == null ? 0 : this.idsubregion, 
                iddepartamento: this.iddepartamento == null ? 0 : this.iddepartamento
            }
        });
    },
    buscarindicador(item){
        this.idindicador = item.idindicador;
        this.filtrarporindicador();
    },
    clearsearch(){
        this.DataGeometas = [];
        this.search = '';
        this.idindicador = null;
        this.idperiodo = null;
        this.idsubregion = null;
        this.iddepartamento = null;
        this.idmunicipio =null;
        this.MesaggeAlert = '';
        this.NombreIndicador = '';
    },
    deletegeometa(item){
      const index = this.DataGeometas.indexOf(item);
      if (confirm("Desea eliminar el registro?")) {
        this.DataGeometas.splice(index, 1);
        this.loading = true;
        this.eliminargeometa({params: {idgeometa: item.idgeometa }});
      }
    },
    editgeometa(item){
      this.IndexGeometa = this.DataGeometas.indexOf(item);
      this.DataEditGeometas = Object.assign({}, item);
      this.dialog = true;
      this.Filtrarmunicipio();
      if (this.DataEditGeometas.idsubregion == 0)
        this.DataEditGeometas.idsubregion = null;
      if (this.DataEditGeometas.iddepartamento == 0)
        this.DataEditGeometas.iddepartamento = null;  
      if (this.DataEditGeometas.idmunicipio == 0)
        this.DataEditGeometas.idmunicipio = null;               
    },
    PreventGuardar(){
      this.$validator.validateAll().then(result => {
        let Errores = '';
        if (!result) {
          this.$validator.errors.items.forEach(element => {
            Errores = Errores + "( " + element.msg + " ), ";
          });
          this.MesaggeAlert =
            "La validación del formulario contiene errores " + Errores;
          return;
        } else {
            this.GuardarMetas();
        }
      });
    },
    GuardarMetas(){
      if (this.IndexGeometa > -1) {
        Object.assign(this.DataGeometas[this.IndexGeometa],this.DataEditGeometas);
        this.ActualizarGeometa({data: this.DataEditGeometas })
        this.loading = true;        
      } else
      {
        if (this.DataEditGeometas.iddesagregacion == null)
        {
            this.MesaggeAlert = 'debe seleccionar una desagregación'
            return;
        }
        if (this.DataEditGeometas.valor <= 0)
        {
            this.MesaggeAlert = 'debe ingresar un valor mayor que cero'
            return;
        }
        
        this.InsertarGeometa({data: this.DataEditGeometas })
        this.filtrar();
        this.loading = true; 
        console.log('El proceso de guardar termino')
      }
      this.dialog = false;
    },
    newgeometa() {
        this.dialog = true;
        this.IndexGeometa = -1;
        this.DataEditGeometas = {
                general:true,
                iddepartamento: this.iddepartamento = null,
                iddesagregacion:null,
                idgeometa:0,
                idmeta:null,
                idmunicipio: this.idmunicipio = null,
                idperiodo: this.idperiodo = null,
                idsubregion: this.idsubregion = null,
                valor:0
        }
    }, 
    Selecionarindicador (item){
        this.MesaggeAlert = '';
        this.NombreIndicador = '';
        this.NombreIndicador =  item.nombre;
        this.getmetasperiodo({params: {idindicador: item.idindicador, idperiodo: this.DataEditGeometas.idperiodo }});
    }
  },
  computed: {
    ...mapGetters("mensaje", ["ginformation", "gnodata", "gnosearch"]),
    ...mapGetters(["ggeometasfiltradas"
        , "gDepartamentos"
        , "gSubregiones"
        , "gperiodos"
        , "gMunicipiosByelemento"
        , "gindicadoresterritorializacion"
        , "gdesagregacionpoblacional"
        , "gmetas"]), 
  },

  created() {    
    this.getSubregiones({params: {pdet: false, todas: true }});   
    this.getDepartamentos();
    this.aperiodicidad({params: {periodicidad: 'V'}});
    this.get_indicadorbyterritorializacion();
    this.get_desagregacionpoblacional();
  },
  $_veeValidate: {
    validator: "new"
  },    
  watch: {
    ggeometasfiltradas() {       
        this.DataGeometas = this.ggeometasfiltradas;
    },
    ginformation() {
      if (this.loading) {
        this.MesaggeInfo = this.ginformation;
        this.snack = true;
        this.buttontext = "aceptar";
        console.log(this.MesaggeInfo.mensajeRespuesta);
        this.loading = false;
        if (this.idindicador == null)
            this.filtrar();
        else
            this.filtrarporindicador();
      }
    },
    gmetas(){
        console.log('gmetas', this.gmetas)
        if (this.gmetas != null)
        {
            if (this.gmetas.length > 0 )
            {
                this.DataEditGeometas.idmeta = this.gmetas[0].idmeta;
            } else
            {
                this.MesaggeAlert = 'El indicador seleccionado no tiene metas en el periodo seleccionado'
            }
        } else {
            this.MesaggeAlert = 'No se encontraron elementos del indicador seleccionado'
        }
        
    }
  }
};
</script>